import { Card, CardBody, Col } from "reactstrap";
import { ToDoHeading } from "../../../../Constants/Constants";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import MarkAllAsFinished from "./MarkAllAsFinished";
import TodoListBody from "./TodoListBody";
import { P } from "../../../../AbstractElements";

const TodoBody = () => {
  return (
    <Col xl="9" className="xl-70 box-col-12">
      <Card>
        <CommonCardHeader title={ToDoHeading} tagClass="mb-0"/>
          <CardBody>
          <div className="todo">
            <div className="todo-list-wrapper">
              <div className="todo-list-container">
                <MarkAllAsFinished />
                <TodoListBody />
              </div>
            </div>
            <div className="notification-popup hide">
              <P>
                <span className="task" />
                <span className="notification-text" />
              </P>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TodoBody;
